import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import DashBoardLayerEight from "../components/DashBoardLayerEight";

const HomePageEight = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* DashBoardLayerEight */}
        <DashBoardLayerEight />
      </MasterLayout>
    </>
  );
};

export default HomePageEight;
